export default "__VITE_ASSET__tH_caygD__"